module.exports = __webpack_public_path__ + "70c67ae18f931687720d390f0ef7227a.svg";